<template>
  <v-row>
    <!-- <p>{{ ItemRow }}</p> -->
    <v-col class="pb-0" cols="12" sm="6" md="5">
      <v-text-field
        dark
        readonly
        outlined
        :value="ItemRow.ItemName"
        label="Item Name"
      ></v-text-field>
    </v-col>
    <v-col class="my-0" cols="12" sm="6" md="2">
      <v-text-field
        dark
        outlined
        :value="ItemRow.exp.toLocaleString()"
        :prefix="ItemRow.UnitType.toUpperCase()"
        @input="InputEvent"
        :rules="[IsNum]"
        :label="ItemRow.UnitType.toUpperCase() + ' QTY'"
      ></v-text-field>
    </v-col>
    <v-col class="my-0" cols="12" sm="6" md="2">
      <v-text-field
        dark
        outlined
        :prefix="ItemRow.cash || ''"
        :value="ItemRow.unitPrice.toLocaleString()"
        @input="InputEvent2"
        :rules="[IsNum]"
        :label="ItemRow.UnitType.toUpperCase() + ' PRICE'"
      ></v-text-field>
    </v-col>
    <v-col class="my-0" cols="12" sm="6" md="3">
      <v-text-field
        dark
        outlined
        readonly
        disabled
        :prefix="ItemRow.cash || ''"
        :value="TotalPrice ? TotalPrice.toLocaleString() : TotalPrice"
        :label="'TOTAL ' + ItemRow.UnitType.toUpperCase() + ' PRICE'"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    ItemRow: { type: Object, required: true },
  },
  computed: {
    TotalPrice() {
      return this.ItemRow.unitPrice * this.ItemRow.exp;
    },
  },
  watch: {
    // TotalPrice() {
    //   if (!this.ItemRow.exp) this.ItemRow.exp = this.ItemRow.qty;
    // }
  },
  methods: {
    IsNum(v) {
      return !isNaN(v.replace(/,/g, "")) || "it is number";
    },
    InputEvent(v) {
      if (isNaN(v.replace(/,/g, ""))) return;
      this.ItemRow.exp = Number(v.replace(/,/g, ""));
    },
    InputEvent2(v) {
      if (isNaN(v.replace(/,/g, ""))) return;
      this.ItemRow.unitPrice = Number(v.replace(/,/g, ""));
    },
    EventCall(v) {
      // console.log(v.key);
      if (isNaN(v.key.replace(/,/g, ""))) this.ItemRow.exp = 123;
      return true;
      //   alert("@input");
      // this.$emit("qty", v);
    },
    OnpriceChange(v) {
      //   console.log(v);
      //   alert("@input");
      this.$emit("price", v);
    },
  },
};
</script>
